import { stagingEdgeCdnBaseUrl } from "@hypertune/sdk/src/shared";
import { Env } from "./type";

const env: Env = {
  NAME: "staging",
  FRONTEND_BASE_URL: "https://app.staging.hypertune.com",
  BACKEND_BASE_URL: "https://app.staging.hypertune.com",
  EDGE_CDN_BASE_URL: stagingEdgeCdnBaseUrl,
};

export default env;
